export default __webpack_public_path__ + "static/media/bg5.957d6824.jpg";